import { render } from "./PasswordPageHeaderCmp.vue?vue&type=template&id=2d62bf77"
import script from "./PasswordPageHeaderCmp.vue?vue&type=script&lang=js"
export * from "./PasswordPageHeaderCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__